import { useRef } from 'react'
import { Vect2D } from '../ZoomAndPanImg'

type ZoomAndPanImgOptions = {
  disableWheelZoom?: boolean
  zoomSpeed?: number
  minScale?: number
  maxScale?: number
  paddingTopFix?: number
}
const zoomAndPanDefaultOptions: ZoomAndPanImgOptions = {
  disableWheelZoom: false,
  zoomSpeed: 0.001,
  minScale: 0.001,
  maxScale: 10,
  paddingTopFix: 32,
}

export const useZoomAndPanRefs = (
  optionsFromProps?: ZoomAndPanImgOptions | undefined,
) => {
  const divRef = useRef<HTMLDivElement>(null)
  const imgRef = useRef<HTMLImageElement>(null)
  const divWrapperRef = useRef<HTMLDivElement>(null)
  const rightClickDoubleClick = useRef<number>(0)
  const middleClickDoubleClick = useRef<number>(0)
  const panning = useRef(false)
  const startPosition = useRef<Vect2D>({ x: 0, y: 0 })
  const firstRender = useRef(true)

  const _options = useRef({
    ...zoomAndPanDefaultOptions,
    ...(optionsFromProps || {}),
  })

  return {
    divRef,
    imgRef,
    divWrapperRef,
    rightClickDoubleClick,
    middleClickDoubleClick,
    panning,
    startPosition,
    firstRender,
    _options,
  }
}
